import { Button, Grid, Typography, WithStyles, withStyles } from "@material-ui/core";
import React, { Component } from "react";
import _ from "lodash";
import {
  MyPATDialog,
  MyPATDropdown,
  MyPATTextArea,
  MyPATTextField,
} from "../../../../../../common";
import MyPATCalendar from "../../../../../../common/MyPATCalendar";
import SearchBarWithChips from "../../../../../common/SearchBarWithChips";
import { contentManagementService } from "../../../../../service";

import { styles } from "./styles";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { showMsg } from '../../../../../../course/actions/loaderAlert'

interface RouteParams {
  id?: string,
  type?: string;
}
interface Props extends WithStyles<typeof styles>, RouteComponentProps<RouteParams> {
  showVersionPopup: boolean;
  packageResponse: any;
  toggleVersionPopup: () => void;
  history: any;
  goalList: any[];
  showMsg: any,
  viewPlanData: any;
}

interface State {
  formData: {
    masterId: string;
    name: string;
    sku: string;
    skuText: string;
    skuNumber: number | string;
    expiryDate: string;
    startDate: string;
    duration: number;
    onboardingInterval: {
      startDate: string;
      endDate: string;
    };
    contentPreferences:any;
    packageAdmins: any;
    courseDetails: any;
    includedPackages: any;
    description: string;
    type: string;
    goalLevels: any;
    phaseAlignment: any;
    targetYears: any;
  };
}

class CourseVersionPopup extends Component<Props, State> {
  state: State = {
    formData: {
      masterId: "",
      name: "",
      sku: "",
      skuText: "",
      skuNumber: 0,
      duration: 0,
      expiryDate: "",
      startDate: "",
      onboardingInterval: {
        startDate: "",
        endDate: "",
      },
      contentPreferences:{},
      packageAdmins: [],
      courseDetails: [],
      includedPackages: [],
      description: "",
      type: "",
      goalLevels: [],
      phaseAlignment: {
        id: "",
        name: "",
        startDate: "",
        endDate: "",
      },
      targetYears: [],
    },
  };
  componentDidMount() {
    const { packageResponse } = this.props;
    if(!packageResponse || _.isEmpty(packageResponse)) {
      return;
    }
    const updatedFormData = { ...this.state.formData };
      updatedFormData.name = packageResponse.name;
      updatedFormData.masterId = packageResponse._id;
      updatedFormData.expiryDate = packageResponse.exipryDate;
      updatedFormData.startDate = packageResponse.startDate;
      updatedFormData.duration = packageResponse.duration;
      if (packageResponse.hasOwnProperty('coursePlanId') && packageResponse.coursePlanId && packageResponse.status !== 'DRAFT') {
        this.setState({
          formData: updatedFormData,
        });
        packageResponse &&
          packageResponse.coursePlanId &&
          contentManagementService.getCousePlanApiById(packageResponse.coursePlanId).then(({ coursePlan }) => {
            // console.log({ response }, 'course');
            const updatedFormData = { ...this.state.formData };

            updatedFormData.type = coursePlan.type;
            this.setState({ formData: updatedFormData });
          });
        
      }
  }
  handleDisableversion = () => {
    const { formData } = this.state;
    const phaseAlignment = { ...formData.phaseAlignment };
    const onBoarding = { ...formData.onboardingInterval };
    if (
      formData.name == "" ||
      formData.skuNumber === "" ||
      formData.skuText === "" ||
      phaseAlignment.name === ""
    ) {
      return true;
    } else {
      return false;
    }
  };
  createVersion = () => {
    const { history, packageResponse } = this.props;
    let payload = { ...this.state.formData };
    if (payload.goalLevels.length === 0) {
      //@ts-ignore
      delete payload.goalLevels;
      //goallevels
      //name populate done
      //calender done
      //sku type number done
    }
    delete payload.contentPreferences;
    payload.targetYears = [2025];
    payload.expiryDate = packageResponse.expiryDate;
    payload.courseDetails = packageResponse.courseDetails;
    payload.includedPackages = packageResponse.includedPackages;
    payload.packageAdmins = packageResponse.packageAdmins;
    if(packageResponse.type === "standard"){
    contentManagementService.updateVersion(payload).then((res: any) => {
      let responseId = _.get(res, "packageDetails._id", "");
      let masterId = payload.masterId;
      const cloneCoursePlanData=JSON.parse(JSON.stringify(this.props.viewPlanData));
      
      cloneCoursePlanData.packageId=responseId;
      cloneCoursePlanData.status="DRAFT";
       delete cloneCoursePlanData['_id'];

      contentManagementService.createCoursePlan(cloneCoursePlanData).then((coursePlanResponse)=>{
       const coursePlanres = coursePlanResponse.statusCode === 200
        if (responseId && coursePlanres) {
          // history.push(`/course-Management/create-standard-course/`+responseId)
          history.push(
            `/course-Management/create-standard-course/${responseId}?masterId=${masterId}&type=version`
          );
          // return res
          this.props.toggleVersionPopup();
        } else{
          this.props.showMsg(coursePlanResponse.responseMessage, 'error')
        }
      });
    });
  }
  if(packageResponse.type === "combo"){
    if(packageResponse.includedPackages.length>0){
      const comboStandard ={...this.state.formData}
      if (comboStandard.goalLevels.length === 0) {
        //@ts-ignore
        delete comboStandard.goalLevels;
      }
      delete comboStandard.contentPreferences;
      comboStandard.targetYears = [2025];
      comboStandard.expiryDate = packageResponse.expiryDate;
      comboStandard.includedPackages = packageResponse.includedPackages;
      comboStandard.packageAdmins = packageResponse.packageAdmins;
      contentManagementService.updateVersion(comboStandard).then((res: any) => {
        let responseId = _.get(res, "packageDetails._id", "");
        let masterId = comboStandard.masterId;
        const cloneCoursePlanData=JSON.parse(JSON.stringify(this.props.viewPlanData));
        
        cloneCoursePlanData.packageId=responseId;
        cloneCoursePlanData.status="DRAFT";
         delete cloneCoursePlanData['_id'];
  
        contentManagementService.createCoursePlan(cloneCoursePlanData).then((coursePlanResponse)=>{
          const coursePlanres = coursePlanResponse.statusCode === 200
          if (responseId && coursePlanres) {
            // history.push(`/course-Management/create-standard-course/`+responseId)
            history.push(
              `/course-Management/create-standard-course/${responseId}?masterId=${masterId}&type=version`
            );
            // return res
            this.props.toggleVersionPopup();
          }else{
            this.props.showMsg(coursePlanResponse.responseMessage, 'error')
          }
        });
      });
    }else{
      const comboGoal ={...this.state.formData}
      if (comboGoal.goalLevels.length === 0) {
        //@ts-ignore
        delete payload.goalLevels;
      }
      comboGoal.targetYears = [2025];
      comboGoal.courseDetails = packageResponse.courseDetails;
      comboGoal.expiryDate = packageResponse.expiryDate;
      comboGoal.packageAdmins = packageResponse.packageAdmins;
      let preferences = JSON.parse(JSON.stringify(packageResponse.contentPreferences))
      let validPreferences =  [
        'scheduledTests',
        'chapterTests',
        'conceptTests',
        'studyNotes',
        'video',
    ]
    for(var prop in preferences) {
      if(preferences.hasOwnProperty(prop)) {
          if(!validPreferences.includes(prop)) {
              delete preferences[prop];
          }
      }
  }
  comboGoal.contentPreferences = preferences


      contentManagementService.updateVersion(comboGoal).then((res: any) => {
        let responseId = _.get(res, "packageDetails._id", "");
        let masterId = comboGoal.masterId;
        const cloneCoursePlanData=JSON.parse(JSON.stringify(this.props.viewPlanData));
        
        cloneCoursePlanData.packageId=responseId;
        cloneCoursePlanData.status="DRAFT";
         delete cloneCoursePlanData['_id'];
  
        contentManagementService.createCoursePlan(cloneCoursePlanData).then((coursePlanResponse)=>{
          const coursePlanres = coursePlanResponse.statusCode === 200
          if (responseId && coursePlanres) {
            // history.push(`/course-Management/create-standard-course/`+responseId)
            history.push(
              `/course-Management/create-standard-course/${responseId}?masterId=${masterId}&type=version`
            );
            // return res
            this.props.toggleVersionPopup();
          } else{
            this.props.showMsg(coursePlanResponse.responseMessage, 'error')
          }
        });
      });
    }
  }
  };
  handleChange = (event: any) => {
    //const {packageResponse } = this.state;
    const response = { ...this.state.formData };
    let { name, value } = event.target;
    switch (name) {
      case "versionName":
        //  value = value.replace(/[^\w\s]/gi, "");
        response.name = value;
        break;
      case "skuText":
        // let skuValue = this.state.packageResponse.sku;
        // const skutext = _.split(response.sku,'-');
        // skuValue = _.concat(value,skutext[1],skutext[2])
        response.skuText = value;
        break;
      case "skuNumber":
        // let skuValueNumber = this.state.packageResponse.sku;
        // const skuNumber = _.split(response.sku,'-');
        // skuValueNumber = _.concat(value,skuNumber[1],skuNumber[2])
        response.skuNumber = value;

      default:
    }
    let dateValue = this.state.formData.startDate;
    const skuTargetYear = new Date(dateValue);
    // let yearValue = dateValue.getFullYear();
   response.sku =
      response.skuText + "-" + response.skuNumber + "-" + skuTargetYear.getFullYear();
    this.setState({
      formData: response,
    });
  };
  handleStartDateChange = (event: any) => {
    const response = { ...this.state.formData };
    response.startDate = event;
    this.setState({
      formData: response,
    });
  };
  handleOnboardingStartDateChnage = (event: any) => {
    const response = { ...this.state.formData };
    let resposneOnBoarding = { ...response.onboardingInterval };
    resposneOnBoarding.startDate = event;
    response.onboardingInterval = resposneOnBoarding;
    this.setState({
      formData: response,
    });
  };
  handleOnboardingEndDateChnage = (event: any) => {
    const response = { ...this.state.formData };
    let resposneOnBoarding = { ...response.onboardingInterval };
    resposneOnBoarding.endDate = event;
    response.onboardingInterval = resposneOnBoarding;
    this.setState({
      formData: response,
    });
  };
  handleCourseAdminNames = (evn: any) => {
    // let value = _.get(evn,"label",[])
    // this.state.formData.goalLevels.push(evn)
    let updatedFormData = JSON.parse(JSON.stringify(this.state.formData));

    if (evn && evn.length > 0) {
      let goalList: any = [];
      evn.forEach((data: any) => {
        let element = {
          id: data.id,
          name: data.label,
        };
        goalList.push(element);
      });
      //return goalList;
      updatedFormData.goalLevels = goalList;
      this.setState({
        formData: updatedFormData,
      });
    } else {
      //  let formData = { ...this.state.formData };
      updatedFormData.goalLevels = evn;
      this.setState({
        formData: updatedFormData,
      });
    }

    // this.state.formData.goalLevels.push(this.state.loggedInUserFullName)
  };
  viewPhaseData=()=>{
    const {viewPlanData } = this.props
    let viewPhase:any =[];

   viewPlanData && viewPlanData.phases && viewPlanData.phases.forEach((data:any)=>{
     let date = new Date(data.startDate)
      const month =["January","february","March","April","May","June","July","August","September","October","November","December"]
     let startDate = date.getDate()+" " + month[date.getMonth()] +" "+date.getFullYear()
      let phaseAlignment = data.name.toString() +" Ownwards " + startDate
      viewPhase.push(phaseAlignment)
    })
    return viewPhase 
  }
  handleDescriptionChange = (event: any) => {
    const response = { ...this.state.formData };
    response.description = event.target.value;
    this.setState({
      formData: response,
    });
  };

  handlePhaseChange = (selectedData: string) => {
    const { viewPlanData } = this.props;
    const phaseFormData = { ...this.state.formData };
    const selectedDataName = selectedData.split(" Ownwards");
    viewPlanData.phases.forEach((requiredData: any) => {
      if (requiredData.name == selectedDataName[0].toString()) {
        let phaseAlignment = {
          id: requiredData._id,
          name: requiredData.name,
          startDate: requiredData.startDate,
          endDate: requiredData.endDate,
        };
        phaseFormData.phaseAlignment = phaseAlignment;
      }
    });

    this.setState({ formData: phaseFormData });
  };
  render() {
    const { showVersionPopup, classes, packageResponse } = this.props;
    const { formData } = this.state;
    const Onboarding = { ...formData.onboardingInterval };
    // No need to check for duplicate bttn show and hide bcz their is no version for testseries
    return (
      <MyPATDialog
        isApplyCustom
        isfixedDialogActions
        dialogOpen={showVersionPopup}
        dialogHasActions={true}
        onDialogClose={this.props.toggleVersionPopup}
        dialogHeading={
          <Typography className={classes.dialogTitle}>
            Add version in {packageResponse.name}
          </Typography>
        }
        isAlignCenter={true}
        customButtonVariant="withoutBorderCloseIcon"
        isCustomBackground={false} //Check
        isborderDialogAction={false}
        customDialogActions={
          <Grid container justify="flex-end">
            <Button
              style={{
                marginTop: "15px",
              }}
              variant="contained"
              color="primary"
              disabled={this.handleDisableversion()}
              onClick={this.createVersion}
            >
              Create Version
            </Button>
          </Grid>
        }
        otherDialogProps={{
          fullWidth: true,
          // maxWidth: 'sm',
        }}
      >
        <Grid container justify="flex-start" spacing={16}>
          <Grid item xs={6}>
            <Typography className={classes.inputLable}>
              Version Name<span className={classes.colorRed}>*</span>{" "}
            </Typography>
            <MyPATTextField
              placeholder="Version 1"
              required
              fullWidthControl
              type="string"
              value={formData.name}
              name="versionName"
              onChange={this.handleChange.bind(this)}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.inputLable}>
              SKU<span className={classes.colorRed}>*</span>{" "}
            </Typography>
            <Grid container spacing={16}>
              <Grid item xs={6}>
                <MyPATTextField
                  placeholder="E.g. JEE"
                  required
                  fullWidthControl
                  value={formData.skuText}
                  name="skuText"
                  onChange={this.handleChange.bind(this)}
                />
                <span className={classes.smallInfo}>Atleast 3 characters </span>
              </Grid>
              <Grid item xs={6}>
                <MyPATTextField
                  placeholder="01"
                  required
                  fullWidthControl
                  value={formData.skuNumber}
                  name="skuNumber"
                  onChange={this.handleChange.bind(this)}
                />
                <span className={classes.smallInfo}>
                  Value must be numeric{" "}
                </span>
              </Grid>
            </Grid>
          </Grid>
          {/* calendar */}
          <Grid item xs={6} className={classes.customCalendar}>
            <Typography className={classes.inputLable}>
              Start Date <span className={classes.colorRed}>*</span>{" "}
            </Typography>
            <MyPATCalendar
              fullWidthControl
              date={formData.startDate}
              placeholder="Select Start Date"
              minDate={new Date()}
              maxDate={packageResponse.expiryDate}
              onChange={this.handleStartDateChange.bind(this)}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.inputLable}>End Date </Typography>
            <MyPATCalendar
              fullWidthControl
              date={packageResponse.expiryDate}
              disabled={true}
              placeholder="Select End Date"
              name="endDate"
            />
          </Grid>
          {/*  */}
          <Grid item xs={6}>
            <Typography className={classes.inputLable}>
              Onboarding Interval<span className={classes.colorRed}>*</span>{" "}
            </Typography>
            <Grid container spacing={16}>
              <Grid item xs={6} className={classes.customCalendar} style={{display: 'flex', alignItems: 'center'}}>
                <MyPATCalendar
                  fullWidthControl
                  date={Onboarding.startDate}
                  minDate={formData.startDate}
                  maxDate={packageResponse.expiryDate}
                  placeholder="Start Date"
                  onChange={this.handleOnboardingStartDateChnage.bind(this)}
                />
                <span style={{ marginLeft:10, marginRight:'-5px', marginBottom:10, fontSize:18, transform: "scaleX(2)"}}>-</span>
              </Grid>
              <Grid item xs={6} className={classes.customCalendar}>
                <MyPATCalendar
                  fullWidthControl
                  date={Onboarding.endDate}
                  minDate={Onboarding.startDate}
                  maxDate={packageResponse.expiryDate}
                  placeholder="End Date"
                  name="onBoardingEndDate"
                  onChange={this.handleOnboardingEndDateChnage.bind(this)}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Typography className={classes.inputLable}>
              Select Goal Level (optional)
            </Typography>
            <SearchBarWithChips
              suggestions={this.props.goalList}
              placeholderText="Select Goal Level"
              onSelection={this.handleCourseAdminNames}
              //loggedInUserFullName={this.state.goalName}
              classes={{ root: classes.searchBarChips }}
              notFound="No User Found"
              isClearable={true}
              backspaceRemoves={true}
            />
          </Grid>
          {/*  */}
          <Grid item xs={12}>
            <Typography className={classes.inputLable} style={{ fontSize: 14 }}>
              Align to Master Plan at (Version Plan will become same to master
              at this point)
              <span className={classes.colorRed}>*</span>
            </Typography>
            <MyPATDropdown
              placeholder="Select Phases"
              dropdownItems={this.viewPhaseData()}
              selectedItem={formData.phaseAlignment._id}
              labelKey="name"
              valueKey="_id"
              onChange={this.handlePhaseChange}
            />
          </Grid>
          {/*  */}
          <Grid item xs={12} className={classes.manageTextarea}>
            <Typography className={classes.inputLable}>Description</Typography>
            <MyPATTextArea
              placeholder=""
              multiline
              fullWidthControl
              value={formData.description}
              className={classes.customTextarea}
              name="description"
              onChange={this.handleDescriptionChange}
              rows={1}
            />
          </Grid>
          {/* Button */}
        </Grid>
      </MyPATDialog>
    );
  }
}

const mapStateToProps = (state: any) => ({
  viewPlanData: _.get(state, 'courseMangementData.contentManagementData.viewPlanData', {}),
});
const mapdispatchtoprops = (dispatch: any) => bindActionCreators({
  showMsg: showMsg,
  
}, dispatch);


// @ts-ignore
export default connect(mapStateToProps,mapdispatchtoprops)(withRouter(withStyles(styles)(CourseVersionPopup)));
